import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import {
  useGetContractTemplate,
  usePutContractTemplate,
} from 'services/templates/contract-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const EditContractTemplate = () => {
  const id = useParamId('/templates');

  const { t } = useTranslation();
  const navigate = useNavigate();

  const contractTemplate = useGetContractTemplate(id);

  const updateContractTemplate = usePutContractTemplate(id);

  const goBackToContractTemplate = () =>
    navigate(`/templates/contract/${id}/form`);

  const onUpdateContractTemplate = async (values: IContractTemplateForm) => {
    const {
      digitalDistributionSection,
      physicalDistributionSection,
      merchDistributionSection,
      channelDistributionSection,
      ...contractTemplate
    } = middleware.template.contractTemplate.formToQuery(values);

    if (
      !digitalDistributionSection &&
      !physicalDistributionSection &&
      !merchDistributionSection &&
      !channelDistributionSection
    ) {
      return toast.error(t('formik-error.at-least-one-distribution'));
    }

    await updateContractTemplate.mutateAsync(
      {
        ...contractTemplate,
        physicalDistributionSection,
        digitalDistributionSection,
        merchDistributionSection,
        channelDistributionSection,
      },
      {
        onSuccess: goBackToContractTemplate,
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.Contract
      tittle={t('contract-template.contract.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.save`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.contract.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        version: contractTemplate.data?.version ?? 0,
        items: contractTemplate.data
          ? middleware.template.contractTemplate.queryToForm(
              contractTemplate.data
            )
          : contractTemplateUtil.contract.initialValues,
      }}
      onSubmit={onUpdateContractTemplate}
    />
  );
};

export default EditContractTemplate;
